export const STORE_PRESELECTED_SUBSCRIPTION = "STORE_PRESELECTED_SUBSCRIPTION";
export const STORE_PRESELECTED_COUPON_CODE = "STORE_PRESELECTED_COUPON_CODE";
export const STORE_ANALYTICS_ID = "STORE_ANALYTICS_ID";
